import { useState, ChangeEvent } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Page, Header, Content } from '@backstage/core-components';
import { Tabs, Tab, Box } from '@material-ui/core';
import { ExceptionCaseList } from './ExceptionCaseList';
import { ExceptionCaseDetail } from './ExceptionCaseDetail';
import { ExceptionSettingsComponent } from './ExceptionSettings';

const CasesAndSettings = () => {
  const [tab, setTab] = useState(0);

  return (
    <>
      <Tabs
        value={tab}
        onChange={(_e: ChangeEvent<{}>, value: number) => setTab(value)}
        indicatorColor="primary"
        textColor="primary"
      >
        <Tab label="Exception Cases" />
        <Tab label="Settings" />
      </Tabs>
      <Box mt={2}>
        {tab === 0 && <ExceptionCaseList />}
        {tab === 1 && <ExceptionSettingsComponent />}
      </Box>
    </>
  );
};

export const ExceptionsPage = () => {
  return (
    <Page themeId="tool">
      <Header
        title="Exceptions Admin"
        subtitle="Manage exception requests and settings"
      />
      <Content>
        <Routes>
          <Route path="/" element={<CasesAndSettings />} />
          <Route path="/cases/:caseId" element={<ExceptionCaseDetail />} />
        </Routes>
      </Content>
    </Page>
  );
};
